import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const RouteGuard = ({ allowedRoutes, children }) => {
	const location = useLocation();
	const navigate = useNavigate();

	useEffect(() => {
		if (allowedRoutes.length === 0) {
			return;
		}

		if (!allowedRoutes.includes(location.pathname)) {
			navigate('/not-authorized');
		}
	}, [allowedRoutes, location.pathname, navigate]);

	return children;
};

export default RouteGuard;
